import React, {useState} from 'react';
import { Container, Row, Col, Form, FormGroup } from 'reactstrap';
import {toast} from 'react-toastify';
// import "../styles/addorder.css";
import Helmet from '../components/Helmet/Helmet';

import {db,storage} from '../firebase.config';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { collection, addDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import useAuth from '../custom-hooks/useAuth';

const AddOrder = () => {
 
  const {currentUser} = useAuth()

  const [enterShipperName, setEnterShipperName] = useState('');
  const [enterShipperEmail, setEnterShipperEmail] = useState('');
  const [enterRecipient1, setEnterRecipient1] = useState('');
  const [enterCategory, setEnterCategory] = useState('');
  const [enterShipperAddress, setEnterShipperAddress] = useState('');
  const [enterProductImg, setEnterProductImg] = useState(null);
  const [enterRecipientAddress, setEnterRecipientAddress] = useState('');
  const [enterRecipientEmail, setEnterRecipientEmail] = useState('');
  const [enterRecipientNum, setEnterRecipientNum] = useState('');
  const [enterShipperNum, setEnterShipperNum] = useState('');
  const [enterOrigin, setEnterOrigin] = useState('');
  const [enterDestination, setEnterDestination] = useState('');
  const [enterWeight, setEnterWeight] = useState('');
  const [enterProduct, setEnterProduct] = useState('');
  const [enterFreight, setEnterFreight] = useState('');
  const [enterPickupDate, setEnterPickupDate] = useState('');
  const [enterComments, setEnterComments] = useState('');
  const [enterPackage, setEnterPackage] = useState('');
  const [enterCarrier, setEnterCarrier] = useState('');
  const [enterShipmentMode, setEnterShipmentMode] = useState('');
  const [enterQuantity, setEnterQuantity] = useState('');
  const [enterDeliveryDate, setEnterDeliveryDate] = useState('');
  const [enterShipmentType, setEnterShipmentType] = useState('');
  const [enterPaymentMode, setEnterPaymentMode] = useState('');
  const [enterCurrentLoc, setEnterCurrentLoc] = useState('');
  
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate()

  const addProduct = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    // ======= add product to firebase database =======
    try {
      const docRef = await collection(db, "products");
  
      const storageRef = ref(
        storage,
        `productImages/${Date.now() + enterProductImg.name}`
      );
      const uploadTask = uploadBytesResumable(storageRef, enterProductImg);

      const referenceNumber = Math.floor(Math.random() * 9000000000) + 1000000000;
      const RealReferenceNumber = referenceNumber.toString();

      const myType = "Shipment";
      const myWebsite = "https://eugogatelogistics.com/order-portal"
  
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // handle upload progress
        },
        (error) => {
          setLoading(false);
          toast.error("Image not uploaded! Error: " + error.message);
        },
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
  
          // generate tracking pin
          const trackingPin = Math.random().toString(36).substring(2, 8);
  
          await addDoc(docRef, {
            shipperName: enterShipperName,
            shipperEmail: enterShipperEmail,
            shipperAddress: enterShipperAddress,
            shipperNumber: enterShipperNum,
            recipient: enterRecipient1,
            recipientAddress: enterRecipientAddress,
            recipientEmail: enterRecipientEmail,
            recipientNum: enterRecipientNum,
            origin: enterOrigin,
            destination: enterDestination,
            weight: enterWeight,
            item: enterProduct,
            product: enterProduct,
            freight: enterFreight,
            pickupDate: enterPickupDate,
            comments: enterComments,
            package: enterPackage,
            carrier: enterCarrier,
            shipmentMode: enterShipmentMode,
            quantity: enterQuantity,
            deliveryDate: enterDeliveryDate,
            shipmentType: enterShipmentType,
            referenceNumber: RealReferenceNumber,
            paymentMode: enterPaymentMode,
            currentLoc: enterCurrentLoc,
            category: enterCategory,
            imgUrl: downloadURL,
            myType: myType,
            myWebsite: myWebsite,
            addedBy: currentUser.uid, // add the uid of the current user who added the product
            displayName: currentUser.displayName
          });
          setLoading(false);
          toast.success("Order added successfully!");
          navigate("/mini/dashboard/all-orders");
        }
      );
    } catch (err) {
      setLoading(false);
      toast.error("Product not added! Error: " + err.message);
    }
  };
  
  
  
  return (
    <Helmet title="Add Order">
    <section>
    <Container style={{justifyContent: 'center', alignItems: 'center', width: '100%', }}>
    <Row style={{
              backgroundColor: '#f8f9fa',
              border: '0',
              justifyContent: 'center',
              padding: '0.5rem',
              width: '100%'
            }}>
          <Col>
            {
              loading ? <h2 className='py-5 font-bold text-4xl text-center'>Creating Consignment, Please wait... <div role="status">
              <svg aria-hidden="true" class="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-purple-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
              </svg>
              <span class="sr-only">Loading...</span>
          </div></h2> : <>
               <h2 className='font-bold text-5xl text-center'>Add Consignment</h2>
               <h2 className='mb-5'>Shipper Information</h2>
            <Form onSubmit={addProduct}>
              <FormGroup className="form__group">
                <span>Shipper's name</span>
                <input type="text" placeholder='John Doe' value={enterShipperName} onChange={e=> setEnterShipperName(e.target.value)} required />
              </FormGroup>
              
              <FormGroup className="form__group">
                <span>Shipper's email</span>
                <input type="email" placeholder='john@example.com'  value={enterShipperEmail} onChange={e=> setEnterShipperEmail(e.target.value)} required />
              </FormGroup>

              <div className='d-flex align-items-center justify-content-between gap-5'>
              <FormGroup className="form__group w-50">
                <span>Shipper's address</span>
                <input type="text" placeholder='East Legon, Street 24, Accra, Ghana'  value={enterShipperAddress} onChange={e=> setEnterShipperAddress(e.target.value)} required />
              </FormGroup>

              <FormGroup className="form__group w-50">
                <span>Shipper's  Phone Number</span>
                <input type="text" placeholder='+23350649174' value={enterShipperNum} onChange={e=> setEnterShipperNum(e.target.value)} required />
              </FormGroup>
              </div>

              <h4 className='mb-5 mt-5'>Receiver Information</h4>
              <FormGroup className="form__group">
              <span>Recipient Name</span>
                <input type="text" placeholder='Mike Doe'  value={enterRecipient1} onChange={e=> setEnterRecipient1(e.target.value)} required />
              </FormGroup>

              <FormGroup className="form__group">
                <span>Recipient Address</span>
                <input type="text" placeholder='Via Principedi Scordia 69, 90139 Palermo Sicilia Italy'  value={enterRecipientAddress} onChange={e=> setEnterRecipientAddress(e.target.value)} required />
              </FormGroup>

              <div className='d-flex align-items-center justify-content-between gap-5'>
              <FormGroup className="form__group w-50">
                <span>Recipient's email</span>
                <input type="email" placeholder='john@example.com'  value={enterRecipientEmail} onChange={e=> setEnterRecipientEmail(e.target.value)} required />
              </FormGroup>

              <FormGroup className="form__group w-50">
                <span>Recipient's  Phone Number</span>
                <input type="text" placeholder='+23350649174' value={enterRecipientNum} onChange={e=> setEnterRecipientNum(e.target.value)} required />
              </FormGroup>
              </div>

              <h4 className='mb-5 mt-5'>Shipment Information</h4>
              <FormGroup className="form__group">
              <span>Origin</span>
                <input type="text" placeholder='Ghana'  value={enterOrigin} onChange={e=> setEnterOrigin(e.target.value)} required />
              </FormGroup>

              <FormGroup className="form__group">
              <span>Destination</span>
                <input type="text" placeholder='Italy'  value={enterDestination} onChange={e=> setEnterDestination(e.target.value)} required />
              </FormGroup>

              <FormGroup className="form__group">
              <span>Weight</span>
                <input type="text" placeholder='50KG'  value={enterWeight} onChange={e=> setEnterWeight(e.target.value)} required />
              </FormGroup>

              <FormGroup className="form__group">
              <span>Product name</span>
                <input type="text" placeholder='Gold Bars'  value={enterProduct} onChange={e=> setEnterProduct(e.target.value)} required />
              </FormGroup>

              <FormGroup className="form__group">
              <span>Total Freight</span>
                <input type="number" placeholder='50'  value={enterFreight} onChange={e=> setEnterFreight(e.target.value)} required />
              </FormGroup>

              <FormGroup className="form__group">
              <span>Pick-up Date</span>
                <input type="date" value={enterPickupDate} onChange={e=> setEnterPickupDate(e.target.value)} required />
              </FormGroup>

              <FormGroup className="form__group">
              <span>Comments</span>
                <input type="text" placeholder='Any Comments'  value={enterComments} onChange={e=> setEnterComments(e.target.value)} required />
              </FormGroup>

              <FormGroup className="form__group">
              <span>Package</span>
                <input type="text" placeholder='Inheritance'  value={enterPackage} onChange={e=> setEnterPackage(e.target.value)} required />
              </FormGroup>

              <FormGroup className="form__group">
              <span>Carrier</span>
                <input type="text" placeholder='Eugogate'  value={enterCarrier} onChange={e=> setEnterCarrier(e.target.value)} required />
              </FormGroup>

              <FormGroup className="form__group">
              <span>Shipment Mode</span>
                <input type="text" placeholder='Air Freight'  value={enterShipmentMode} onChange={e=> setEnterShipmentMode(e.target.value)} required />
              </FormGroup>

              <FormGroup className="form__group">
              <span>Quantity</span>
                <input type="text" placeholder='50 Gold Bars'  value={enterQuantity} onChange={e=> setEnterQuantity(e.target.value)} required />
              </FormGroup>

              <FormGroup className="form__group">
              <span>Delivery Date</span>
                <input type="date"  value={enterDeliveryDate} onChange={e=> setEnterDeliveryDate(e.target.value)} required />
              </FormGroup>

              <FormGroup className="form__group">
              <span>Payment Mode</span>
                <input type="text" placeholder='Cash'  value={enterPaymentMode} onChange={e=> setEnterPaymentMode(e.target.value)} required />
              </FormGroup>

              <FormGroup className="form__group">
              <span>Package Current Location</span>
                <input type="text" placeholder='Ghana'  value={enterCurrentLoc} onChange={e=> setEnterCurrentLoc(e.target.value)} required />
              </FormGroup>

              <div className='d-flex align-items-center justify-content-between gap-5'>
              <FormGroup className="form__group w-50">
              <span>Type of Shipment</span>
                <input type="text" placeholder='Diplomatic Package'  value={enterShipmentType} onChange={e=> setEnterShipmentType(e.target.value)} required />
              </FormGroup>
              
              <FormGroup className="form__group w-50">
                <span>Shipping Status</span>
                <select 
                  className='w-100 p-2'  
                  value={enterCategory} 
                  onChange={e=> setEnterCategory(e.target.value)}
                >
                <option>Status</option>
                  <option value="pending">pending</option>
                  <option value="on hold">On Hold</option>
                  <option value="awaiting payment">Awaiting Payment</option>
                  <option value="awaiting fulfillment">Awaiting Fulfillment</option>
                  <option value="awaiting shipment">Awaiting Shipment</option>
                  <option value="partially shipped">Partially Shipped</option>
                  <option value="awaiting pickup">Awaiting Pickup</option>
                  <option value="completed">Completed</option>
                  <option value="shipped">Shipped</option>
                  <option value="cancelled">Cancelled</option>
                  <option value="declined">Declined</option>
                  <option value="refunded">Refunded</option>
                  <option value="disputed">Disputed</option>
                  <option value="manual verification required">Manual Verification Required</option>
                  <option value="partially refunded">Partially Refunded</option>
                </select>
              </FormGroup>
              </div>

              

              <div>
              <FormGroup className="form__group">
              <span>Package Image = 1180 Width x 1475 Height</span>
                <input type="file" onChange={e=> setEnterProductImg(e.target.files[0])} required />
              </FormGroup>
              </div>

              <button className="bg-blue-500 text-white font-bold rounded-xl w-full" type="submit">Add Order</button>
            </Form>
              </>
            }
          </Col>
        </Row>
      </Container>
    </section>
    </Helmet>
  )
}

export default AddOrder